if (!window.BioGoldGeoMarket) {
  window.BioGoldGeoMarket = true;

  (function () {
    const COOKIE = "biogold-geo";
    const MAX_AGE = 30 * 24 * 60 * 60;
    const MARKETS = ["NZ", "AU"];

    function getCookie(name) {
      const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
      return match ? decodeURIComponent(match[1]) : "";
    }

    function setCookie(name, value) {
      const secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie =
        name + "=" + encodeURIComponent(value) + "; Path=/; Max-Age=" + MAX_AGE + "; SameSite=Lax" + secure;
    }

    function submitCountry(form, country) {
      if (!form || !MARKETS.includes(country)) return;
      setCookie(COOKIE, country);
      const input = form.querySelector("[data-geo-country-input]");
      if (input) input.value = country;
      form.submit();
    }

    function closeMenu(root) {
      const trigger = root.querySelector("[data-geo-trigger]");
      const menu = root.querySelector(".m-geo-selector__menu");
      if (!trigger || !menu) return;
      menu.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      root.classList.remove("is-open");
    }

    function openMenu(root) {
      document.querySelectorAll("[data-geo-selector].is-open").forEach(function (other) {
        if (other !== root) closeMenu(other);
      });
      const trigger = root.querySelector("[data-geo-trigger]");
      const menu = root.querySelector(".m-geo-selector__menu");
      if (!trigger || !menu) return;
      menu.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      root.classList.add("is-open");
    }

    function bindSelectors() {
      document.querySelectorAll("[data-geo-selector]").forEach(function (root) {
        if (root.dataset.bound === "true") return;
        root.dataset.bound = "true";
        const form = root.querySelector("form");
        const trigger = root.querySelector("[data-geo-trigger]");

        if (trigger) {
          trigger.addEventListener("click", function (event) {
            event.preventDefault();
            if (root.classList.contains("is-open")) closeMenu(root);
            else openMenu(root);
          });
        }

        root.querySelectorAll("[data-geo-country]").forEach(function (button) {
          button.addEventListener("click", function () {
            if (button.classList.contains("is-current")) {
              closeMenu(root);
              return;
            }
            submitCountry(form, button.getAttribute("data-geo-country"));
          });
        });
      });

      document.addEventListener("click", function (event) {
        document.querySelectorAll("[data-geo-selector].is-open").forEach(function (root) {
          if (!root.contains(event.target)) closeMenu(root);
        });
      });

      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        document.querySelectorAll("[data-geo-selector].is-open").forEach(closeMenu);
      });
    }

    function previewCountry() {
      const params = new URLSearchParams(window.location.search);
      const preview = (params.get("geo_preview") || "").toUpperCase();
      return MARKETS.includes(preview) ? preview : "";
    }

    function closePopup(popup) {
      popup.hidden = true;
      popup.setAttribute("hidden", "");
      document.body.classList.remove("m-geo-popup-open");
    }

    function openPopup(popup, detected, current) {
      const panel = popup.querySelector('[data-geo-panel="' + detected + '"]');
      if (!panel) return;

      popup.querySelectorAll("[data-geo-panel]").forEach(function (item) {
        item.hidden = true;
      });
      panel.hidden = false;

      const title = panel.querySelector(".m-geo-popup__title");
      const dialog = popup.querySelector('[role="dialog"]');
      if (title && dialog) dialog.setAttribute("aria-labelledby", title.id || "geo-popup-title");

      popup.hidden = false;
      popup.removeAttribute("hidden");
      document.body.classList.add("m-geo-popup-open");

      window.requestAnimationFrame(function () {
        const primary = panel.querySelector("[data-geo-switch]");
        const focusTarget = primary || dialog;
        if (focusTarget && typeof focusTarget.focus === "function") {
          focusTarget.focus({ preventScroll: true });
        }
      });

      function onDismiss() {
        setCookie(COOKIE, current || "NZ");
        closePopup(popup);
      }

      popup.querySelectorAll("[data-geo-switch]").forEach(function (button) {
        button.addEventListener("click", function () {
          submitCountry(popup.querySelector("form"), button.getAttribute("data-geo-switch"));
        });
      });

      popup.querySelectorAll("[data-geo-dismiss]").forEach(function (el) {
        el.addEventListener("click", onDismiss);
      });

      document.addEventListener("keydown", function onKey(event) {
        if (event.key === "Escape" && !popup.hidden) {
          document.removeEventListener("keydown", onKey);
          onDismiss();
        }
      });
    }

    function detectedCountry(data) {
      const values = data && data.detected_values ? data.detected_values : {};
      const handle = values.country && values.country.handle;
      return String(handle || values.country_code || "").toUpperCase();
    }

    function initPopup() {
      const popup = document.querySelector("[data-geo-popup]");
      if (!popup || popup.getAttribute("data-enable") !== "true") return;

      const current = (popup.getAttribute("data-current-country") || "").toUpperCase();
      const forced = previewCountry();
      if (forced) {
        openPopup(popup, forced, current);
        return;
      }

      if (getCookie(COOKIE)) return;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(root + "browsing_context_suggestions.json", { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("geo lookup failed");
          return response.json();
        })
        .then(function (data) {
          const detected = detectedCountry(data);
          if (!MARKETS.includes(detected) || detected === current) return;
          if (getCookie(COOKIE)) return;
          openPopup(popup, detected, current);
        })
        .catch(function () {});
    }

    function init() {
      bindSelectors();
      initPopup();
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();
}
